import type { IconProps } from '../types/IconProps.ts';
export const Gem: IconProps = {
    name: 'Gem',
    children: [
        `<path d="M12.02 21.98h-.04L2.02 9.03A.02.02 0 0 1 2.04 9h19.92q.03 0 .02.03z" />`,
        `<path d="m2 9 3.4-5.1A2 2 0 0 1 7.08 3h9.86a2 2 0 0 1 1.66.9L22 9" />`,
        `<path d="M10.67 3 8.32 8.3a2 2 0 0 0-.07 1.44L12 21M13.33 3l2.36 5.3a2 2 0 0 1 .06 1.44L12 21" />`,
    ]
};